import { Dialog, Pane, SelectField, TextInputField, TextareaField, Alert, Text } from 'evergreen-ui';
import { normalizeTimeInput } from './normalizeTimeInput';
import { isOvernightShift } from './overnightSplit';

export default function TurniOrarioFissoModal({
  isOpen,
  onClose,
  onSave,
  rangeInputs,
  setRangeInputs,
  userName,
  collaboratorsList,
}) {
  const isEditMode = !!rangeInputs.batch_id;
  // A cavallo di mezzanotte il backend salva notte + coda del giorno dopo:
  // il periodo non si sceglie, come nel turno singolo.
  const overnight = isOvernightShift(rangeInputs);
  const dateInvalid = rangeInputs.from_date && rangeInputs.to_date && rangeInputs.from_date > rangeInputs.to_date;
  const isConfirmDisabled =
    !rangeInputs.operator_name ||
    !rangeInputs.from_date ||
    !rangeInputs.to_date ||
    !rangeInputs.start_time ||
    !rangeInputs.end_time ||
    (!rangeInputs.shift_period && !overnight) ||
    !!dateInvalid;

  return (
    <Dialog
      isShown={isOpen}
      title={isEditMode ? 'Modifica turni con ripetizione orario fisso' : 'Assegna turni con ripetizione orario fisso'}
      onCloseComplete={onClose}
      confirmLabel={isEditMode ? 'Aggiorna intervallo' : 'Assegna turni'}
      intent="success"
      onConfirm={onSave}
      isConfirmDisabled={isConfirmDisabled}
    >
      {isEditMode && (
        <Alert intent="warning" marginBottom={16}>
          <Text size={300}>
            La modifica aggiornerà tutti i turni dell'intervallo, sovrascrivendo eventuali modifiche individuali.
          </Text>
        </Alert>
      )}

      <SelectField
        label="Collaboratore *"
        value={rangeInputs.operator_name}
        onChange={(e) => setRangeInputs({ ...rangeInputs, operator_name: e.target.value })}
      >
        <option value="">-- Seleziona collaboratore --</option>
        <option value={userName}>{userName} (io)</option>
        {collaboratorsList.map(collab => {
          const fullName = `${collab.nome || ''} ${collab.cognome || ''}`.trim() || collab.email;
          return (
            <option key={collab.id} value={fullName}>{fullName}</option>
          );
        })}
      </SelectField>

      <Pane display="flex" gap={16}>
        <TextInputField
          label="Dal *"
          type="date"
          flex="1"
          value={rangeInputs.from_date}
          onChange={(e) => setRangeInputs({ ...rangeInputs, from_date: e.target.value })}
        />
        <TextInputField
          label="Al *"
          type="date"
          flex="1"
          value={rangeInputs.to_date}
          onChange={(e) => setRangeInputs({ ...rangeInputs, to_date: e.target.value })}
          isInvalid={!!dateInvalid}
          validationMessage={dateInvalid ? 'La data fine deve essere uguale o successiva alla data inizio' : undefined}
        />
      </Pane>

      <Pane display="flex" gap={16}>
        <TextInputField
          label="Ora inizio *"
          type="text"
          flex="1"
          placeholder="es. 11 oppure 11:00"
          value={rangeInputs.start_time}
          onChange={(e) => setRangeInputs({ ...rangeInputs, start_time: e.target.value })}
          onBlur={(e) => setRangeInputs({ ...rangeInputs, start_time: normalizeTimeInput(e.target.value) })}
        />
        <TextInputField
          label="Ora fine *"
          type="text"
          flex="1"
          placeholder="es. 16 oppure 16:00"
          value={rangeInputs.end_time}
          onChange={(e) => setRangeInputs({ ...rangeInputs, end_time: e.target.value })}
          onBlur={(e) => setRangeInputs({ ...rangeInputs, end_time: normalizeTimeInput(e.target.value) })}
        />
      </Pane>

      {overnight ? (
        <SelectField label="Periodo *" value="notte" disabled>
          <option value="notte">Notte (+ coda il giorno dopo)</option>
        </SelectField>
      ) : (
        <SelectField
          label="Periodo *"
          value={rangeInputs.shift_period || ''}
          onChange={e => setRangeInputs({ ...rangeInputs, shift_period: e.target.value })}
          isInvalid={!rangeInputs.shift_period}
          validationMessage={!rangeInputs.shift_period ? 'Il periodo è obbligatorio' : undefined}
        >
          <option value="" disabled>-- Seleziona periodo --</option>
          <option value="coda_della_notte">Coda della notte</option>
          <option value="giorno">Giorno</option>
          <option value="notte">Notte</option>
        </SelectField>
      )}

      <SelectField
        label="Tipologia"
        value={rangeInputs.is_overtime ? 'true' : 'false'}
        onChange={e => setRangeInputs({ ...rangeInputs, is_overtime: e.target.value === 'true' })}
      >
        <option value="false">Turno standard</option>
        <option value="true">Straordinario</option>
      </SelectField>

      <TextareaField
        label="Note (facoltative)"
        value={rangeInputs.notes}
        onChange={e => setRangeInputs({ ...rangeInputs, notes: e.target.value })}
      />
    </Dialog>
  );
}
